import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object } from "yup";
import { OrderFormValues } from "src/models/Order.model";
import { showToast } from "src/utils/showToaster";
import OrderForm from "../Layouts/OrderForm";
import { useAddOrderMutation } from "src/services/OrderService";

type Props = {
  onClose: () => void;
};

const AddOrderWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: OrderFormValues = {
    _id: "",
    orderUnqId: "",
    userId: "",
    userName: "",
    mobile: "", // ✅ added missing field
    productId: null,
    productName: "",
    productVarientCode: "",
    productMrp: 0,
    productDiscount: 0,
    productQuantity: 0,
    allOrderQuantity: 0,
    allOrderMrp: 0,
    allOrderDisocuntAmount: 0,
    totalDiscountAmount:0,
    totalCourierCharges: 0,
    orderAmt: 0,
    productDiscountAmount: 0,
    productEffectivePrice: 0,
    discountType: "",
    couponCode: "",
    couponDiscount: 0,
    referralCode: "",
    referralToDiscountAmount: 0,
    referralByDiscountAmount: 0,
    walletDiscountAmount: 0,
    faculty:
            [{
                facultyName: "",
            }],
    modeId: "",
    modeName: "",
    orderStatus: "",
    paymentStatus: "",
    paymentGateway: "",
    transactionId: "",
    razorpayOrderId: "",
    productImage: [], // ✅ initialize as empty array
    deliveryDetails: {
      address: "",
      city: "",
      state: "",
      pincode: "",
      firstName: "",
      lastName: "",
      email: "",
      landmark: "",
      altMobile: "",
      country: "",
      mobile: "",
    },
    additionalNotes: "",
    transactions: [],
    isDeleted: false,
    isActive: true, 
    createdAt: "",
    updatedAt: "",
  };

  const [addOrder] = useAddOrderMutation();

  // Validation Schema
  const validationSchema = object().shape({});

  // Handle Submit
  const handleSubmit = (
    values: OrderFormValues,
    { setSubmitting, resetForm }: FormikHelpers<OrderFormValues>
  ) => {
    const payload = { ...values };
    addOrder(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <OrderForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddOrderWrapper;
